module.exports = __webpack_public_path__ + "static/media/fruits_31.2a8c2a69.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_31.csv
// module id = 697
// module chunks = 0